import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { useDraftStore } from '../../store/draftStore';
import { useRegistrationsStore } from '../../store/registrationsStore';

/**
 * Redirect inteligente da raiz "/" do sistema:
 *  - Deslogado → /login
 *  - Logado + draft completo + moderação aprovada → /review (terminar pagamento)
 *  - Logado + draft em andamento → /register (continuar de onde parou)
 *  - Logado + já tem registros → /minha-colecao (hub do usuário recorrente)
 *  - Logado + sem nada ainda → /register (primeira presença)
 */
export default function LandingIndex() {
  const user = useAuthStore((s) => s.user);
  const draft = useDraftStore((s) => s.draft);
  const ownedCount = useRegistrationsStore((s) =>
    user ? s.getByOwner(user.email).length : 0,
  );

  if (!user) return <Navigate to="/login" replace />;

  const hasDraftProgress =
    draft.displayName.length > 0 || draft.message.length > 0 || !!draft.photoDataUrl;
  const draftReady =
    draft.displayName.trim().length > 0 &&
    draft.message.trim().length > 0 &&
    !!draft.photoDataUrl &&
    draft.moderation.status === 'approved';

  if (draftReady) return <Navigate to="/review" replace />;
  if (hasDraftProgress) return <Navigate to="/register" replace />;
  if (ownedCount > 0) return <Navigate to="/minha-colecao" replace />;
  return <Navigate to="/register" replace />;
}
